import { FC, ReactElement, useMemo, useState } from 'react';
import { MoraDialog } from './MoraDialog';
import { MoraDialogContext } from './MoraDialogContext';

type Props = {
  children?: ReactElement;
};

/** Componente que contiene al modal de Mora y que permite
 * activarlo.
 */
export const MoraBoundary: FC<Props> = ({ children }) => {
  const [showDialog, setShowDialog] = useState<boolean>(false);

  const dialogContext = useMemo(() => ({ showDialog: () => setShowDialog(true) }), [setShowDialog]);

  return (
    <>
      <MoraDialog show={showDialog} close={() => setShowDialog(false)} />
      <MoraDialogContext.Provider value={dialogContext}>{children}</MoraDialogContext.Provider>
    </>
  );
};
